<template>
  <div class="geofence-context-menu-container">
    <button
      type="button"
      class="btn btn-sm btn-no-borders"
      @click="deleteGeofence">
      <IconDelete />
      {{ $t('actions.remove') }}
    </button>
  </div>
</template>

<script lang="ts">
  import { IconDelete } from '@/common/icons/monochrome';

  export default {
    components: {
      IconDelete,
    },
    methods: {
      deleteGeofence() {
        // To be overwritten in GeofenceListAndMapbox.vue
      },
    },
  };
</script>

<style lang="scss">
  .geofence-context-menu-container {
    button {
      svg {
        stroke: var(--defaultButtonColor);
      }
    }
  }
</style>
